/** @format */

export enum PageTypeEnum {
  CATEGORY = 'c',
  FAMILY = 'f',
  STATIC = 's',
}
